import React from "react";
import { Modal } from "react-bootstrap";
import "./ErrorViewer.css";

function ErrorViewer(props) {
  let title = "Error Loading Book";
  let message,
    link,
    linkMessage = "";

  // bang bang forces truthy/falsy values into boolean
  const isRnib = !!props.isRnib;

  switch (props?.error?.status) {
    case 401:
      title = "Log in required";
      message = "You must log in to access the Bookshare Reader.";
      if (isRnib) {
        link = process.env.REACT_APP_RNIB_BASE_URL + "login";
        linkMessage = "Log in to RNIB Bookshare";
      } else {
        link = process.env.REACT_APP_BOOKSHARE_BASE_URL + "login";
        linkMessage = "Log in to Bookshare";
      }
      break;
    case 403:
      title = "Access denied";
      message = "You do not have permission to view this title.";
      if (isRnib) {
        link = process.env.REACT_APP_RNIB_BASE_URL + "account";
        linkMessage = "Return to my homepage";
      } else {
        link = process.env.REACT_APP_BOOKSHARE_BASE_URL + "myBookshare";
        linkMessage = "Return to My Bookshare";
      }
      break;
    case 404:
      title = "Title not found";
      message = "The requested title could not be found";
      if (isRnib) {
        link = process.env.REACT_APP_RNIB_BASE_URL + "account";
        linkMessage = "Return to my homepage";
      } else {
        link = process.env.REACT_APP_BOOKSHARE_BASE_URL + "myBookshare";
        linkMessage = "Return to My Bookshare";
      }
      break;
    default:
      title = "There was a problem";
      message =
        "Something went wrong. Try again later. If issues persist please contact customer support.";
      if (isRnib) {
        link = process.env.REACT_APP_RNIB_BASE_URL + "about/contact-us";
      } else {
        link = process.env.REACT_APP_BOOKSHARE_BASE_URL + "contactUs";
      }
      linkMessage = "Contact Customer Support";
  }

  return (
    <Modal
      className="errorViewer"
      centered
      show={props.show}
      backdrop="static"
      aria-labelledby="errorModalLabel"
    >
      <Modal.Header>
        <Modal.Title id="errorModalLabel">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
        <a href={link}>{linkMessage}</a>
      </Modal.Body>
    </Modal>
  );
}

export default ErrorViewer;
